



























import {
    defineComponent,
    PropType,
} from '@vue/composition-api';
import { PeerUrgencyExperimentVariant } from '@core/models/user/flags';
import {
    EventCardSource,
    HomeEventCardSource,
} from '@src/app/enums';

export default defineComponent({
    name: 'EventBettorNumber',
    props: {
        bettorNumber: {
            type: Number as PropType<number>,
            required: true,
        },
        designVariant: {
            type: String as PropType<PeerUrgencyExperimentVariant>,
            required: false,
            default: PeerUrgencyExperimentVariant.None,
        },
        eventCardSource: {
            type: String as PropType<EventCardSource>,
            required: false,
            default: HomeEventCardSource.Default,
        },
    },
    setup() {
        return {
            HomeEventCardSource,
        };
    },
});

